<template>
    <div>
        <router-view></router-view>
        <div class="content-body">
            <div class="widgets">
            </div>
        </div>
    </div>
</template>
<script>
    import Header from '../../layouts/Header.vue'
    import PersonWidget from '../person/PersonWidget.vue'
    import CompanyWidget from '../company/CompanyWidget.vue'

    export default {
        name: 'Dashboard',
        data () {
            return {
                profiles: null,
                msg: 'Page FirstRoute'
            }
        },
        mounted: function(){
        },
        components: {
            'app-header': Header,
            'PersonWidget': PersonWidget,
            'CompanyWidget': CompanyWidget
        },
        methods: {
            edit: function(id){
                this.$router.push('/person/'+id);
            },
            increment: function () {
                this.$store.commit('increment')
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/Dashboard.vue